module.exports = __webpack_public_path__ + "labioplastika_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_6_after.jpg
// module id = 1077
// module chunks = 0